import SearchText from "components/common/search_sort/SearchText";
// import InputField from "components/UI/InputField";
import InputField from "components/UI/InputField/InputField";
import { SEARCH_NAMES } from "constant/search/search";
import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";

type SearchTextActivateProps = {
  searchLabel: string;
  placeholder?: string;
  buttonText?: string;
  navigateToSearch?: boolean;
  defaultSearchText?: string;
  onSearchActivate?: () => void;
};

const SearchTextActivate: React.FC<SearchTextActivateProps> = ({
  searchLabel,
  placeholder,
  buttonText,
  navigateToSearch,
  defaultSearchText,
  onSearchActivate,
}: SearchTextActivateProps) => {
  const { handleSubmit, reset, control } = useForm();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const sTName = SEARCH_NAMES.SEARCH_TEXT;

  const onSubmit = async (data: any) => {
    const { [sTName]: searchText } = data;
    console.log(sTName, searchText);
    if (navigateToSearch) {
      const navUrl = "/search" + (searchText ? `?${sTName}=${searchText}` : "");
      navigate(navUrl);
    } else {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      if (searchText) {
        newSearchParams.set(sTName, searchText);
      } else {
        newSearchParams.delete(sTName);
      }
      setSearchParams(newSearchParams);
    }

    if (onSearchActivate) {
      onSearchActivate();
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>{searchLabel}</div>
        <div>
          <InputField
            name="searchText"
            control={control}
            key={defaultSearchText}
            defaultValue={defaultSearchText ?? ""}
            label="ključna reč"
          />
        </div>
        <DivSubmit>
          <input type="submit" value={buttonText ?? "OK"} />
        </DivSubmit>
      </form>
    </div>
  );
};

export const DivSubmit = styled.div`
  margin-top: 0.5rem;
`;

export default SearchTextActivate;
